import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import image from "../assets/gradiant.jpg";
import KeyModel from "../subComponent/KeyModel";
import { onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import { firebaseAuth } from "./Firebase.js";
import { TailSpin } from "react-loader-spinner";
import { AiOutlineArrowLeft, AiOutlineWarning } from "react-icons/ai";
import { useStateContext } from "../contexts/ContextProvider";
import DispalayUserDetails from "./DispalayUserDetails";
import LoginIcon from "../assets/login.png";
import Account from "../assets/login-back.jpg";
const Login = () => {
  const { user } = useStateContext();
  const [loaderSpinner, SetLoaderSpinner] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 3000);
  }, []);

  const removeError = () => {
    setTimeout(() => {
      setError();
    }, 3000);
  };
  const handleLogin = async () => {
    SetLoaderSpinner(true);
    try {
      const { email, password } = formValues;
      if (!email && password) {
        setError("email is required");
        SetLoaderSpinner(false);
        removeError();
      }
      if (!password && email) {
        setError("password is required");
        SetLoaderSpinner(false);
        removeError();
      }

      if (!password && !email) {
        setError("please enter a valid email and password");
        SetLoaderSpinner(false);
        removeError();
      }

      await signInWithEmailAndPassword(firebaseAuth, email, password);
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        setError("User not found"); 
        SetLoaderSpinner(false);
      }
    }
  };

  onAuthStateChanged(firebaseAuth, (currentUser) => {
    if (currentUser) SetLoaderSpinner(false);
    // if (currentUser) navigate("/");
  });

  return (
    <Component>
      <Left>
        <Back onClick={() => navigate(`/`)}>
          <AiOutlineArrowLeft />
        </Back>
        <img src={Account} alt="credentails" srcset="" />
        <Overlay></Overlay>
        <Controls>
          <div className="login_button"  onClick={() => navigate(`/login`)} >Login</div>
          <div className="signin_button"  onClick={() => navigate(`/signup`)}>Sign-in</div>
        </Controls>
      </Left>
      <Right>
        {user ? (
          <DispalayUserDetails />
        ) : loading ? (
          <Form>
            {error && (
              <Error>
                <p>
                  {" "}
                  <AiOutlineWarning /> {error}
                </p>{" "}
              </Error>
            )}

            <div className="image-div">
              <div className="border-image-div">
                <img src={LoginIcon} alt="" srcset="" />
              </div>
            </div>
            <div className="header-div">
              <h2>Sign In</h2>
            </div>

            <input
              type="email"
              placeholder="📧 Email Address"
              name="email"
              value={formValues.email}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  [e.target.name]: e.target.value,
                })
              }
            />

            <input
              type="password"
              placeholder="🔑 Password"
              name="password"
              value={formValues.password}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  [e.target.name]: e.target.value,
                })
              }
            />
            <Button>
              <button onClick={handleLogin}>
                {loaderSpinner ? (
                  <TailSpin
                    height="20"
                    width="20"
                    color="#ca0dca"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                ) : (
                  "Sign In"
                )}{" "}
              </button>
            </Button>
            <p className="create">
              Dont have an accout yet ?{" "}
              <Link className="Link" to="/signup">
                Create Account
              </Link>{" "}
            </p>
          </Form>
        ) : (
          <TailSpin
            height="120"
            width="120"
            color="#ca0dca"
            ariaLabel="tail-spin-loading"
            radius="0.2"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        )}

        <Blur></Blur>
        <Blur2></Blur2>
        <Blur3></Blur3>
        <Blur4></Blur4>
      </Right>
    </Component>
  );
};

export default Login;

const Component = styled.div`
  background-color: #292929;
  backdrop-filter: blur(10px);
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 1140;
`;
const imageMovement = keyframes`
  0% {
    transform: translateY(20px)
  
  }

  49% {
    transform: translateY(0)
   
  }

  100% {
    transform: translateY(20px)
   
  }
`;

const Left = styled.div`
  height: 100vh;
  width: 40vw;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  img {
    width: 110%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: 481px) {
    width: 0;
  }
  overflow: hidden;
`;

const Back = styled.div`
  position: absolute;
  top: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 10px;
  height: 40px;
  width: 40px;
  background-color: rgba(255, 255, 255, 0.7);
  &:hover{
    background-color: rgba(207, 84, 143, 0.879);
    color: #fff;
  }
  z-index: 1200;
  svg {
    font-size: 19px;
    font-weight: 900;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
`;
const Controls = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1100;
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  align-items: flex-start;
  width: 10vw;

  .signin_button {
    margin-top: 10px;
    margin-right: 1px;
    padding-left: 10px;
    cursor: pointer;
  }
  .login_button {
    position: relative;
    background-color: #f4f1f1;
    color: #1f1d1d;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 10vw;
    margin-right: 1px;
    height: 43px;
    cursor: pointer;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;
    padding-left: 10px;
    &::before {
      content: "";
      position: absolute;

      background-color: transparent;
      bottom: -50px;
      right: 9px;
      height: 50px;
      width: 27px;
      border-top-right-radius: 25px;
      box-shadow: 0 -25px 0 0 #f4f1f1;
    }
    &::after {
      content: "";
      position: absolute;

      background-color: transparent;
      bottom: 41px;
      right: 9px;
      height: 50px;
      width: 27px;
      border-top-right-radius: 25px;
      box-shadow: 0 -25px 0 0 #f4f1f1;
      transform: rotateX(180deg);
    }
  }
`;

const Right = styled.div`
  height: 100vh;
  width: 60vw;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 99;
  background-color: #f4f1f1;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  box-shadow: -3px -2px 5px 0px rgba(0, 0, 0, 0.33);
  -webkit-box-shadow: -3px -2px 5px 0px rgba(0, 0, 0, 0.33);
  -moz-box-shadow: -3px -2px 5px 0px rgba(0, 0, 0, 0.33);
  @media (max-width: 481px) {
    width: 104vw;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`;

const Form = styled.div`
  width: 27vw;
  padding: 20px;
 
  border: 1px solid white;
  background-color: rgba(255, 255, 255, 0.2);
  margin-top: 40px;
  backdrop-filter: blur(20px);
  display: flex;
  flex-direction: column;
  height: fit-content;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.12);
  border-width: 1px;
  border-style: solid;

  border-top-left-radius: 44px;
  border-bottom-right-radius: 44px;
  position: relative;

  @media (max-width: 481px) {
    width: 70vw;
  }

  .image-div {
    height: 70px;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 70px;
      width: 70px;
      object-fit: contain;
    }
    .border-image-div {
      height: 70px;
      width: 70px;
      background-color: #d485bf;
      border-radius: 50%;
    }
  }
  .header-div {
    width: 100%;
    height: 50px;
    display: flex;

    align-items: center;
    justify-content: center;
  }
  h2 {
    padding: 2px;
    padding-bottom: 4px;
  }
  input {
    width: 80%;

    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 1px solid black;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 0px;
    padding: 10px;
    outline: none;
    margin: 14px auto;
    font-size: 14px;
    background-color: transparent;
  }
  .tag {
    margin-top: 20px;
    margin-left: 14px;
  }
  button {
    margin-top: 20px;
    padding: 12px 4px;
    width: 80%;
    outline: none;
    border-radius: 4px;
    background-color: #de80c2;
    border: 0.1px solid #f4aee5;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(to bottom, #f4aede, #f46cd4);
    cursor: pointer;
    box-shadow: 0 1px 0 rgb(255 255 255 / 40%) inset;
    box-shadow: 2px 2px 7px 3px rgba(215, 70, 162, 0.4);

    :hover {
      transform: scale(1.02);
    }
    transition: 0.4s ease-in-out;
  }
  .create {
    margin: 30px auto;
    padding-bottom: 10px;
    font-size: 12px;
  }

  .Link {
    text-decoration: none;
    color: #2d1941;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Error = styled.div`
  position: absolute;
  top: -17px;
  width: 90%;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(20px);
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid #f1a4a4;
  border-radius: 10px;
  p {
    color: red;
    font-size: 14px;
  }
`;

const Button = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Blur = styled.div`
  position: absolute;
  width: 20rem;
  height: 14rem;
  border-radius: 50%;
  //background: #fdddfc;
  background: #f9b2f7;
  filter: blur(54px);
  top: 20px;
  right: 10%;
  z-index: -1;
`;
const Blur2 = styled.div`
  position: absolute;
  width: 20rem;
  height: 14rem;
  border-radius: 50%;
  //background: #f0ddfd;
  background: #ce95f4;

  filter: blur(54px);
  top: 150px;
  right: 17%;
  z-index: -3;
`;

const Blur3 = styled.div`
  position: absolute;
  width: 24rem;
  height: 14rem;
  border-radius: 50%;
  background: #efe9ac;

  filter: blur(44px);
  top: 140px;
  right: 4%;
  z-index: -2;
`;
const Blur4 = styled.div`
  position: absolute;
  width: 39rem;
  height: 10rem;
  border-radius: 50%;
  background: #fdd8de;

  filter: blur(94px);
  bottom: 0;
  right: 0%;
  z-index: -1;
`;

const IconPlaceholder = styled.div`
  display: flex;
  align-items: center;
  color: #999;
`;
